import { Link } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { cn } from "@/lib/utils"

const TABS = [
  { href: "/profile", label: { id: "profile.tab_details" } },
  { href: "/profile/programs", label: { id: "profile.tab_programs" } },
  { href: "/profile/password", label: { id: "profile.tab_password" } },
] as const

const HREFS = { details: "/profile", programs: "/profile/programs", password: "/profile/password" } as const

export function ProfileSubNav({ active }: { active: keyof typeof HREFS }) {
  const intl = useIntl()
  const activeHref = HREFS[active]

  return (
    <nav className="flex items-end gap-6 border-b border-hairline">
      {TABS.map((tab) => {
        const isActive = tab.href === activeHref
        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={cn(
              "-mb-px border-b-2 px-1 py-3 text-sm no-underline",
              isActive
                ? "border-accent font-medium text-accent-display"
                : "border-transparent text-ink-body hover:text-ink-display",
            )}
          >
            {intl.formatMessage(tab.label)}
          </Link>
        )
      })}
    </nav>
  )
}
